import {
  FileRvtColor,
  FileXlsColor,
  File3dmColor,
  FileDefaultColor,
  FileDocColor,
  FileDwfColor,
  FileDwgColor,
  FileDxfColor,
  FileIfcColor,
  FileJpegColor,
  FileJpgColor,
  FileMp3Color,
  FileMp4Color,
  FileNwcColor,
  FileNwdColor,
  FileNwfColor,
  FilePdfColor,
  FilePngColor,
  FilePptColor,
  FileRfaColor,
  FileRteColor,
  FileSkpColor,
  FileTextColor,
  FolderNormalColor,
} from 'patternx-svg';

const renderFileIcon = (fileSuffix: string, size = 32) => {
  const suffix = fileSuffix?.toLowerCase();
  let icon = null;
  switch (suffix) {
    case 'folder':
      icon = <FolderNormalColor size={size} />;
      break;
    case 'rvt':
      icon = <FileRvtColor size={size} />;
      break;
    case 'dwg':
      return <FileDwgColor size={size} />;
    case 'xls':
    case 'xlsx':
      return <FileXlsColor size={size} />;
    case '3dm':
      return <File3dmColor size={size} />;
    case 'doc':
    case 'docx':
      return <FileDocColor size={size} />;
    case 'dwf':
      return <FileDwfColor size={size} />;
    case 'dxf':
      return <FileDxfColor size={size} />;
    case 'ifc':
      return <FileIfcColor size={size} />;
    case 'jpeg':
      return <FileJpegColor size={size} />;
    case 'jpg':
      return <FileJpgColor size={size} />;
    case 'mp3':
      return <FileMp3Color size={size} />;
    case 'mp4':
      return <FileMp4Color size={size} />;
    case 'nwc':
      return <FileNwcColor size={size} />;
    case 'nwd':
      return <FileNwdColor size={size} />;
    case 'nwf':
      return <FileNwfColor size={size} />;
    case 'pdf':
      return <FilePdfColor size={size} />;
    case 'png':
      return <FilePngColor size={size} />;
    case 'ppt':
    case 'pptx':
      return <FilePptColor size={size} />;
    case 'rfa':
      return <FileRfaColor size={size} />;
    case 'rte':
      return <FileRteColor size={size} />;
    case 'skp':
      return <FileSkpColor size={size} />;
    case 'txt':
      return <FileTextColor size={size} />;
    default:
      icon = <FileDefaultColor size={size} />;
  }
  return icon;
};

export default renderFileIcon;
